import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { isFlowStarted, setPersistedRoute } from "@/lib/sessionPersistence";

/**
 * Observa mudanças de rota e persiste a última rota visitada quando o
 * fluxo já foi iniciado (usuário clicou em "Começar agora"). Permite
 * que o PWA restaure o usuário ao ponto onde parou ao reabrir.
 *
 * Não renderiza nada.
 */
const SessionRoutePersistence = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!isFlowStarted()) return;
    setPersistedRoute(pathname);
  }, [pathname]);

  return null;
};

export default SessionRoutePersistence;
